import React from 'react';
import { Modal, QRCode } from 'antd';
import { ButtonCommon, FileUploadModal } from 'components/common';
import { ConfirmPaymentModalProps } from 'types';

const ConfirmPaymentModal: React.FC<ConfirmPaymentModalProps> = ({
  isOpen,
  onClose,
  fileName = 'NH01001709.xls',
  supplierContact = {
    phone: '19000001',
    email: 'Tonhoasen@gmail.com',
    qrCodeUrl: 'https://placehold.co/117x116',
  },
  onBack = () => {},
  onContinue = () => {},
  onUpload,
  customActions,
  contentStep3,
  type = 'đặt',
}) => {
  const [isImporting, setIsImporting] = React.useState(false);
  function onOpenImport(e: React.MouseEvent): void {
    e.preventDefault();
    setIsImporting(true);
    onClose();
  }

  return (
    <>
      <FileUploadModal
        isOpen={isImporting}
        onComplete={onContinue}
        confirmText='Xác nhận đã thanh toán'
        title={'TẢI LÊN CHỨNG TỪ THANH TOÁN'}
        subtitle={'Vui lòng tải lên thông tin hình ảnh và xác nhận với kế toán'}
        acceptedFileTypes={'.xlsx,.xls,.xlsm,.xlm,.png,.jpg,.jpeg,.webp,.gif,.bmp'}
        fileTypesHelpText={'Hỗ trợ các tệp tin excel, png, jpg, gif, bmp, ...'}
        positionButton='center'
        typeModal='upload'
        onClose={function (): void {
          setIsImporting(false);
        }}
        onUpload={onUpload}
      />
      <Modal
        open={isOpen}
        // onCancel={onClose}
        footer={null}
        width={682}
        closable={false}
        className='confirm-payment-modal'
        centered
      >
        {/* Header */}
        <header className='px-6 py-3 border-b rounded-t-lg bg-white'>
          <h2 className='text-xl font-bold text-[var(--textBlack100)]'>XÁC NHẬN THANH TOÁN</h2>
          <p className='text-sm text-[var(--textBlack56)] mt-2'>Vui lòng làm theo các bước dưới đây</p>
        </header>

        {/* Content */}
        <div className='px-6 py-3 max-h-[60vh] overflow-y-auto'>
          <div className='space-y-6'>
            {/* Step 1 */}
            <div className='space-y-1'>
              <div className='px-3'>
                <span className='text-sm font-medium text-[var(--primaryColor)]'>Bước 01: </span>
                <span className='text-sm text-[var(--textBlack56)]'>Tải về tệp excel sản phẩm vừa {type}</span>
              </div>
              <div className='px-3 text-sm text-[var(--textBlack56)]'>
                Hệ thống đã tổng hợp tất cả sản phẩm và thông tin bạn vừa chọn vào tệp
                <span className='font-bold text-[var(--primaryColor500)]'> {fileName}</span>
              </div>
            </div>

            {/* Step 2 */}
            <div className='space-y-1'>
              <div className='px-3'>
                <span className='text-sm font-medium text-[var(--primaryColor)]'>Bước 02: </span>
                <span className='text-sm text-[var(--textBlack56)]'>
                  Gửi tệp vừa tải cho NCC qua thông tin bên dưới và xác nhận thông tin đơn hàng là chính xác
                </span>
              </div>

              {/* Supplier contact info */}
              <div className='px-4 py-3 mt-2'>
                <div className='flex justify-between items-start px-2'>
                  <div className='space-y-3'>
                    <h3 className='text-sm font-bold text-[var(--textBlack100)]'>Thông tin liên hệ nhà cung cấp</h3>

                    {supplierContact.phone && (
                      <p className='pl-4'>
                        <span className='text-sm text-[var(--textBlack56)]'>1. Số điện thoại liên hệ </span>
                        <span className='text-sm font-bold text-[var(--primaryColor500)]'>{supplierContact.phone}</span>
                      </p>
                    )}

                    {supplierContact.email && (
                      <p className='pl-4'>
                        <span className='text-sm text-[var(--textBlack56)]'>2. Liên hệ theo địa chỉ </span>
                        <span className='text-sm font-bold text-[var(--primaryColor500)]'>{supplierContact.email}</span>
                      </p>
                    )}

                    <p className='pl-4 text-sm text-[var(--textBlack56)]'>
                      3. Quét QR để liên hệ với nhà cung cấp qua Zalo
                    </p>
                  </div>
                  <QRCode size={117} className='p-1' value={`https://zalo.me/${supplierContact.phone}`} />
                </div>
              </div>
            </div>

            {/* Step 3 */}
            <div className='space-y-1'>
              <div className='px-3'>
                <span className='text-sm font-medium text-[var(--primaryColor)]'>Bước 03: </span>
                <span className='text-sm text-[var(--textBlack56)]'>Xác nhận và thanh toán</span>
              </div>
              <div className='px-3'>
                <ul className='list-disc pl-6 text-sm text-[var(--textBlack56)]'>
                  {!contentStep3 ? (
                    <li>
                      Sau khi xác nhận thông tin với NCC hoàn toàn đúng, giá sản phẩm chính xác. Vui lòng thanh toán
                      toàn bộ giá tiền và cập nhật chứng từ thanh toán{' '}
                      <a onClick={onOpenImport} className='font-bold text-[var(--primaryColor500)]'>
                        tại đây
                      </a>
                    </li>
                  ) : (
                    contentStep3
                  )}
                  <li className='mt-2'>Nếu sai thông tin, bạn cần trở về để chỉnh sửa thông tin cho chính xác</li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        {/* Action buttons */}
        <div className='px-6 py-4 flex justify-center items-center gap-4 border-t'>
          {!customActions ? (
            <>
              <ButtonCommon color='none' radius='rounded' className='h-10 ' onClick={onBack}>
                Trở lại
              </ButtonCommon>
              <ButtonCommon color='primary' radius='rounded' className='h-10' onClick={onOpenImport}>
                Tải lên chứng từ
              </ButtonCommon>
            </>
          ) : (
            customActions
          )}
        </div>
      </Modal>
    </>
  );
};

export default ConfirmPaymentModal;
